import { useNotificationWizard } from './useNotificationWizard';

/** Variável disponível para interpolação na mensagem de notificação */
export interface NotificationVariable {
  readonly key: string;
  /** Texto que será inserido no campo ao clicar */
  readonly label: string;
  /** Valor de exemplo exibido na pré-visualização */
  readonly example: string;
}

/** Lista base de variáveis disponíveis para personalização da mensagem */
export const NOTIFICATION_VARIABLES: readonly NotificationVariable[] = [
  { key: 'nome', label: '{{nome}}', example: 'Ana' },
  { key: 'turma', label: '{{turma}}', example: 'Turma A' },
  { key: 'curso', label: '{{curso}}', example: 'Excel Avançado' },
];

/**
 * Hook para gerenciar a etapa 2 do wizard — composição da mensagem.
 *
 * Fornece o estado atual de título/corpo/url e handlers de edição.
 *
 * @returns Dados e handlers da etapa de mensagem
 *
 * @example
 * ```tsx
 * const { title, body, url, updateTitle, updateBody, updateUrl } = useNotificationMessage();
 * ```
 */
export function useNotificationMessage() {
  const { wizardState, updateMessage } = useNotificationWizard();
  const { title, body, url } = wizardState.message;

  const updateTitle = (newTitle: string) => updateMessage({ title: newTitle });
  const updateBody = (newBody: string) => updateMessage({ body: newBody });
  const updateUrl = (newUrl: string) => updateMessage({ url: newUrl });

  return {
    title,
    body,
    url,
    updateTitle,
    updateBody,
    updateUrl,
  } as const;
}
